import React from 'react';
import Grid from '@mui/material/Grid2';
import ErrorIcon from '@assets/icons/alert-icon.svg';
import WarningIcon from '@assets/icons/alert-icon.svg';
import SuccessIcon from '@assets/icons/success-alert-icon.svg';
import { Typography } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import Popup from 'OldComponents/Popup';
import PropTypes from 'prop-types';

const PopupMessage = ({ variant, onClose, text, icon, acceptAction }) => {
	const lan = useLanguage();

	const defaultIcons = {
		warn: <img src={WarningIcon} alt='' />,
		success: <img src={SuccessIcon} alt='' />,
		error: <img src={ErrorIcon} alt='' />,
	};

	const MessageIcon = () => {
		if (variant || variant in defaultIcons) {
			return defaultIcons[variant];
		}

		return icon;
	};

	return (
		<Popup
			centered
			width='sm'
			onClose={onClose}
			closeButton
			buttonText={lan.accept}
			buttonOnClick={acceptAction !== null ? acceptAction : onClose}
		>
			<Grid container direction='column' justifyContent='center' spacing={3}>
				<MessageIcon />
				<Grid>
					<Typography align='center'>{text}</Typography>
				</Grid>
			</Grid>
		</Popup>
	);
};

PopupMessage.prototype = {
	variant: PropTypes.oneOf(['success', 'warn', 'error']),
	icon: PropTypes.node,
	onClose: PropTypes.func.isRequired,
	text: PropTypes.string,
	show: PropTypes.bool,
	acceptAction: PropTypes.func,
};

PopupMessage.defaultProps = {
	variant: 'warn',
	acceptAction: null,
};

export default PopupMessage;
